import DateInput from "@/components/Common/DateInput/DateInput.vue";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import { stateItems } from "@/configuration/formConfigurations";
export default {
  components: { DateInput, TimeInput },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems
  })
};
